/**
 * Frontend configuration (build-time). Values here are read by the SPA; change and redeploy the
 * UI to apply. An optional VITE_ env override lets a build tune it without a code edit.
 */

/**
 * How often list/detail views auto-refresh (ms) while the tab is visible. Default 30s.
 * Interim default — planned to become a per-user preference in the Settings tab (see backlog),
 * at which point usePolling will read the user's choice and fall back to this default.
 */
export const POLL_INTERVAL_MS = Number(import.meta.env.VITE_POLL_INTERVAL_MS) || 30_000;
